import { post } from '../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../config'

// 客户端忘记密码 验证账户下一步
export const CHECK_RESET_CLIENT_UPW = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/sys/user/checkResetClientUpw`, data)
}

// 客户端忘记密码-管理端使用uuid修改密码
export const RESET_CLIENT_UPW = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/sys/user/resetClientUpw`, data)
}
